import { onMounted } from "vue";

export function useBaiduTongji(path: string) {
  const tongJi = () => {
    if (process.env.NODE_ENV === "production" && (window as any)._hmt) {
      (window as any)._hmt.push(["_trackPageview", path]);
    }
  };
  onMounted(() => {
    tongJi();
  });
}
